// extracted by mini-css-extract-plugin
export var changeIcon = "_5l-4";
export var container = "_5l-0";
export var divider = "_5l-7";
export var externalLinkIcon = "_5l-1";
export var green = "_5l-5";
export var helpCircleIcon = "_5l-3";
export var iconButton = "_5l-2";
export var red = "_5l-6";